var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{staticClass:"center-aligned",attrs:{"flat":"","solo":"","dense":"","hide-details":"","readonly":"","background-color":"blue-grey darken-3","prefix":_vm.label + ':',"value":_vm.formatDate(_vm.value)}})}
var staticRenderFns = []

export { render, staticRenderFns }